import React, { useMemo } from 'react';
import { BUCKET_URL } from '../utils/env-utils';
import { useScrollAnimation } from './UseScrollAnimation';

interface AnimatedCodeshareProps {
  codeShareFlights: string[];
  style?: React.CSSProperties;
  mainClassName?: string;
  className?: string;
  labelClassName?: string;
  itemHeight?: number;
}

const AnimatedCodeshare: React.FC<AnimatedCodeshareProps> = ({
  mainClassName,
  codeShareFlights,
  className,
  labelClassName,
  itemHeight = 120,
}) => {
  const shouldRotate = codeShareFlights.length > 1;
  const displayFlights = shouldRotate
    ? [...codeShareFlights, ...codeShareFlights]
    : codeShareFlights;

  const itemsHash = useMemo(() => codeShareFlights.join('|'), [codeShareFlights]);

  const { listRef } = useScrollAnimation({
    items: displayFlights,
    globalStartTime: 0,
    itemHeight,
    scrollDuration: 1.5,
    enabled: shouldRotate,
  });

  if (!codeShareFlights.length) return null;

  return (
    <div
      key={itemsHash}
      style={{
        height: `${itemHeight}px`,
        overflow: 'hidden',
        position: 'relative',
        width: 'var(--ac-container-width, 300px)',
      }}
    >
      <ul
        ref={listRef}
        style={{
          margin: 0,
          padding: 0,
          listStyle: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          willChange: 'transform',
        }}
      >
        {displayFlights.map((flightNumber, i) => (
          <li
            key={`${flightNumber}-${i}`}
            style={{
              height: `${itemHeight}px`,
              display: 'flex',
              flexDirection: 'var(--ac-direction, column)' as any,
              alignItems: 'center',
              justifyContent: 'var(--ac-justify, center)' as any,
              gap: 'var(--ac-gap, 6px)',
              overflow: 'hidden',
            }}
          >
            <img
              style={{
                height: 'var(--ac-logo-height, 80px)',
                width: 'auto',
                maxWidth: 'var(--ac-logo-max-width, 280px)',
                objectFit: 'contain',
                display: 'block',
              }}
              src={`${BUCKET_URL}/0350x0090/${flightNumber.split(' ')[0]}.bmp`}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  `${BUCKET_URL}/0350x0090/${flightNumber.split(' ')[0]}.jpg`;
              }}
              alt="Airline Logo"
            />
            <h2
              className={labelClassName}
              style={{ margin: 0, fontWeight: 'bold', fontSize: 'var(--ac-font-size, 3.4rem)' }}
            >
              {flightNumber}
            </h2>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AnimatedCodeshare;